import React from 'react'

import { Portlet, Row, Col, Button } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as CompraCrud from 'services/compra.service'

import * as FormGroups from './formGroups'
import { DownloadAxiosFile } from 'utils'

const FormatoCruceComprasContabilidad = () => {
  const __zariContext = React.useContext(ZariContext)

  const [mesSeleccionado, setMesSeleccionado] = React.useState()
  const [sedes, setSedes] = React.useState([])
  const [sedeSeleccionada, setSedeSeleccionada] = React.useState([])

  const clickDescargarFormatoCruceComprasContabilidad = React.useCallback(() => {
    __zariContext.loader.open('Descargando Reporte Cruce Compras Contabilidad...')
    CompraCrud.descargarFormatoCruceComprasContabilidad({
      mesSeleccionado,
      sedeSeleccionada
    })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers, 'reporte cruce compras contabilidad.xlsx')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [mesSeleccionado, sedeSeleccionada, __zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Reporte Cruce Compras Contabilidad' />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <FormGroups.MesContabilidadSelect value={mesSeleccionado} onChange={e => setMesSeleccionado(e.target.value)} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroups.SedeSelect sedes={sedes} setSedes={setSedes} sedeSeleccionada={sedeSeleccionada} setSedeSeleccionada={setSedeSeleccionada} />
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickDescargarFormatoCruceComprasContabilidad}>Descargar Reporte</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(FormatoCruceComprasContabilidad)
